/**
 * Los filtros que hoy recortan una tabla del backoffice (productos, pedidos),
 * uno por chip, cada uno con su cruz para quitarlo, y "Limpiar todo" al final.
 * Sin filtros no se dibuja: una fila vacia diciendo "ninguno" es ruido.
 */
import { Icono } from '../comunes/Icono';
import type { FiltroActivo } from '../../utilidades/parametros-url';

export interface FiltrosActivosProps<F> {
  activos: FiltroActivo<F>[];
  onCambiar(filtros: F): void;
  onLimpiar(): void;
}

export function FiltrosActivos<F>({ activos, onCambiar, onLimpiar }: FiltrosActivosProps<F>) {
  if (activos.length === 0) return null;

  return (
    <div className="filtros-activos" role="region" aria-label="Filtros activos">
      <span className="filtros-activos-et">Filtrando por:</span>
      <ul>
        {activos.map((activo) => (
          <li key={activo.clave}>
            <button
              type="button"
              className="chip-filtro"
              aria-label={`Quitar filtro ${activo.texto}`}
              onClick={() => {
                onCambiar(activo.sinEste);
              }}
            >
              <span>{activo.texto}</span>
              <Icono nombre="cerrar" />
            </button>
          </li>
        ))}
      </ul>
      <button type="button" className="btn btn-sm btn-suave" onClick={onLimpiar}>
        Limpiar todo
      </button>
    </div>
  );
}
